var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "margins-container" },
    [_vm.isDeltasEnabled ? _c("delta-margins") : _c("anchor-margins")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }